<template>
  <div class="px-4 py-3">
    <div v-if="isLoading" class="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30 z-150">
  <div class="loader border-4 border-white border-t-transparent rounded-full w-12 h-12 animate-spin"></div>
</div>
    <!-- Header -->
    <div class="sticky top-0 bg-white z-50 flex justify-between items-center border-b border-gray-200 py-4 mb-6">
      <h1 class="text-xl font-semibold text-gray-800">Devis N°{{ devis.numero }}</h1>

      <!-- Actions -->
      <div class="flex flex-row sm:items-center sm:space-x-2">

        <!-- Sinon afficher le bouton signature -->
        <button
          v-if="devis.signe === false"
          @click="showSignature = true"
          class="flex items-center gap-2 bg-black text-white text-sm font-semibold rounded-md px-4 py-2 shadow-md hover:shadow-lg transition-shadow"
        >
          <i class="fas fa-file-signature"></i>
          Signez le Devis
        </button>
      </div>
    </div>

    <!-- PDF Viewer -->
    <div class="border border-gray-300 rounded-md overflow-hidden h-[80vh] relative">
      <iframe
        :src="pdfUrl"
        class="w-full h-full"
        style="border:none;"
      ></iframe>

      <!-- Overlay si PDF non disponible -->
      <div
        v-if="!pdfUrl"
        class="absolute inset-0 flex items-center justify-center bg-gray-100 text-gray-500 text-center p-4"
      >
        PDF non disponible
      </div>
    </div>

    <!-- Contrôles du PDF -->
    <div class="flex justify-end mt-2 space-x-2">
      <button
        @click="zoomOut"
        class="bg-gray-200 text-gray-700 px-3 py-1 rounded hover:bg-gray-300 transition"
      >
        -
      </button>
      <button
        @click="zoomIn"
        class="bg-gray-200 text-gray-700 px-3 py-1 rounded hover:bg-gray-300 transition"
      >
        +
      </button>
      <span class="text-gray-600 px-2 py-1">Zoom: {{ (zoom * 100).toFixed(0) }}%</span>
    </div>


    <!-- Modal Signature -->
    <div v-if="showSignature" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-white p-6 rounded-md w-96 relative">
        <h2 class="text-lg font-semibold mb-4">Signez ici</h2>

           <!-- Canvas -->
<canvas 
  ref="paintCanvas"
  class="paint-canvas"
  width="300" 
  height="300"
  @mousedown="startDrawing"
  @mousemove="drawLine"
  @mouseup="stopDrawing"
  @mouseout="stopDrawing"
  @touchstart="startTouch"
  @touchmove="moveTouch"
  @touchend="endTouch"
></canvas>


        <div class="flex justify-between">
          <button @click="clearSignature" class="bg-gray-200 px-4 py-2 rounded">Effacer</button>
          <button @click="submitSignature" class="bg-black text-white px-4 py-2 rounded">Envoyer</button>
        </div>

        <button @click="showSignature = false" class="absolute top-2 right-2 text-gray-500 hover:text-gray-800 text-xl">&times;</button>
      </div>
    </div>

  </div>
</template>

<script setup>
import { ref, watch, nextTick, onMounted } from "vue"
import axios from "axios"

// ----------------------
// Données Devis
// ----------------------
console.log("Initialisation des données du devis")
const devis = ref({})

// Récupérer l'ID du devis depuis l'URL
const pathParts = window.location.pathname.split("/") // découpe le path
const devisId = pathParts[pathParts.length - 1]       // dernier segment = ID
console.log("Devis ID extrait :", devisId)


// Récupérer le token depuis le localStorage
const token = localStorage.getItem("token") // ou "adminToken"
console.log("Token récupéré :", token)


// Fonction pour récupérer le devis spécifique
const fetchDevis = async () => {
  try {
    const res = await axios.get(`https://datafuseweb-95a5588f8542.herokuapp.com/api/clients/devis/${devisId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    devis.value = res.data.devis;
    console.log("Devis récupéré :", devis.value);

  } catch (err) {
    console.error("Erreur récupération devis :", err);
  }
};

// Construire l'URL PDF dynamique
const pdfUrl = ref(`https://datafuseweb-95a5588f8542.herokuapp.com/api/clients/pdf/${devisId}?token=${token}`)
console.log("PDF URL initialisée :", pdfUrl.value)
// ----------------------
// Zoom PDF
// ----------------------
const zoom = ref(1)
const zoomIn = () => {
  zoom.value = Math.min(zoom.value + 0.1, 3)
  console.log("Zoom In :", zoom.value)
  const iframe = document.querySelector("iframe")
  if (iframe) {
    iframe.style.transform = `scale(${zoom.value})`
    iframe.style.transformOrigin = "top left"
  }
}
const zoomOut = () => {
  zoom.value = Math.max(zoom.value - 0.1, 0.5)
  console.log("Zoom Out :", zoom.value)
  const iframe = document.querySelector("iframe")
  if (iframe) {
    iframe.style.transform = `scale(${zoom.value})`
    iframe.style.transformOrigin = "top left"
  }
}

// ----------------------
// Signature Canvas
// ----------------------
const paintCanvas = ref(null)
let context = null

const color = ref("#000000")
const lineWidth = ref(5)
const showSignature = ref(false)

let x = 0, y = 0
let isMouseDown = false

console.log("Setup des variables de dessin")

// Réinitialiser le canvas à chaque ouverture du modal
watch(showSignature, async (val) => {
  console.log("showSignature changé :", val)
  if (val) {
    await nextTick() // attend que le DOM soit rendu
    if (paintCanvas.value) {
      context = paintCanvas.value.getContext("2d")
      context.lineCap = "round"
      context.strokeStyle = color.value
      context.lineWidth = lineWidth.value
      context.clearRect(0, 0, paintCanvas.value.width, paintCanvas.value.height)
      console.log("Canvas initialisé après ouverture modal :", context)
    } else {
      console.log("Canvas introuvable après ouverture modal !")
    }
  }
})

// Récupérer les coordonnées souris/tactile
const getCoordinates = (event) => {
  if (!paintCanvas.value) return { x: 0, y: 0 }
  const rect = paintCanvas.value.getBoundingClientRect()
  let coords
  if (event.touches && event.touches[0]) {
    coords = {
      x: event.touches[0].clientX - rect.left,
      y: event.touches[0].clientY - rect.top
    }
  } else {
    coords = {
      x: event.offsetX ?? event.clientX - rect.left,
      y: event.offsetY ?? event.clientY - rect.top
    }
  }
  console.log("getCoordinates :", coords)
  return coords
}

// Watchers couleur et épaisseur
watch(color, (newColor) => {
  console.log("Couleur changée :", newColor)
  if (context) context.strokeStyle = newColor
})

watch(lineWidth, (newWidth) => {
  console.log("Epaisseur changée :", newWidth)
  if (context) context.lineWidth = newWidth
})

// ----------------------
// Souris
// ----------------------
const startDrawing = (event) => {
  if (!context) {
    console.log("startDrawing : contexte null")
    return
  }
  isMouseDown = true
  const coords = getCoordinates(event)
  x = coords.x
  y = coords.y
  console.log("startDrawing :", x, y)
}

const drawLine = (event) => {
  if (!isMouseDown || !context) {
    console.log("drawLine : rien à dessiner")
    return
  }
  const coords = getCoordinates(event)
  console.log("drawLine de", x, y, "à", coords.x, coords.y)

  context.beginPath()
  context.moveTo(x, y)
  context.lineTo(coords.x, coords.y)
  context.stroke()

  x = coords.x
  y = coords.y
}

const stopDrawing = () => {
  isMouseDown = false
  console.log("stopDrawing")
}

// ----------------------
// Tactile
// ----------------------
const startTouch = (e) => {
  console.log("startTouch")
  startDrawing(e)
}
const moveTouch = (e) => {
  e.preventDefault()
  console.log("moveTouch")
  drawLine(e)
}
const endTouch = () => {
  console.log("endTouch")
  stopDrawing()
}

// ----------------------
// Actions
// ----------------------
const clearSignature = () => {
  if (context && paintCanvas.value) {
    context.clearRect(0, 0, paintCanvas.value.width, paintCanvas.value.height)
    console.log("clearSignature : canvas effacé")
  } else {
    console.log("clearSignature : context ou canvas null")
  }
}

const isLoading = ref(false) // loader

const submitSignature = async () => {
  if (!paintCanvas.value) {
    console.log("submitSignature : canvas null")
    return
  }

  const base64Signature = paintCanvas.value.toDataURL("image/png")
  console.log("submitSignature : signature capturée")

  // Récupérer l'ID du devis depuis l'URL
  const pathParts = window.location.pathname.split("/")
  const devisId = pathParts[pathParts.length - 1]
  console.log("Devis ID :", devisId)

  // Récupérer le token depuis localStorage
  const token = localStorage.getItem("token") // ou "adminToken"
  console.log("Token :", token)

  try {
    isLoading.value = true // afficher le loader

    const response = await axios.post(
      `https://datafuseweb-95a5588f8542.herokuapp.com/api/clients/sign/${devisId}`,
      { signature: base64Signature },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )

    console.log("Signature envoyée ✅", response.data)

    // Mettre à jour l'état local
    showSignature.value = false
    pdfUrl.value = response.data.devis.pdfUrl
    devis.value.accepted = true

    // Rafraîchir la page pour recharger le PDF et état
    window.location.reload()
  } catch (err) {
    console.error("Erreur envoi signature :", err)
  } finally {
    isLoading.value = false // masquer le loader
  }
  
}
onMounted(() => {
  fetchDevis();
});
</script>





<style scoped>
.paint-canvas {
  border: 1px black solid;
  display: block;
  margin: 1rem;
}
.color-picker {
  margin: 1rem 1rem 0 1rem;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
</style>